import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog }) => {
  return (
    <div className="border rounded-lg shadow-md hover:shadow-lg transition">
      {/* Display cover image */}
      <img
        src={blog.coverImage}
        alt={blog.title} aria-hidden="true" 
        className="w-full h-20 sm:h-24  md:h-48 object-cover rounded-lg mb-4"
      />
      <div className='p-2'>
          <h3 className="text-sm md:text-xl font-semibold mb-2 truncate">{blog.title}</h3>
          <p className="hidden md:inline-block text-xs md:text-sm text-gray-600 mb-2 md:mb-4">{blog.description}</p>
          <p className="text-xs text-gray-400">{new Date(blog.date).toLocaleDateString()}</p>
          <Link
            to={`/blogs/${blog.slug}`}
            className="mt-2 md:mt-4 inline-block px-2 md:px-4 md:py-2 w-full bg-pink-600 text-white text-xs md:text-sm font-medium rounded hover:bg-gray-800 transition"
          >
            Read More...
          </Link>
      </div>
    </div>
  );
};

export default BlogCard;
